<template>
  <v-container>
    <v-breadcrumbs
      class="mt-n4"
      large
    >
      <v-btn
        class="text-primary"
        text
        @click="backPrevios()"
      >
        <v-icon>mdi-keyboard-backspace</v-icon>
      </v-btn>
      ເລືອກລູກຄ້າເຂົ້າແຜນເສັ້ນທາງ
      <v-spacer />
      <span class="mr-4">
        <v-icon color="red">mdi-map-marker</v-icon>ຍັງບໍທັນຢູ່ໃນແຜນ
      </span>
      <span>
        <v-icon style="color: #49a3da">mdi-map-marker</v-icon>ຢູ່ໃນແຜນແລ້ວ
      </span>
    </v-breadcrumbs>
    <v-row class="my-n4">
      <v-col
        class="mb-4"
        cols="12"
      >
        <GmapMap
          :center="
            getCenter().lat > 0 || getCenter().lat < 0
              ? getCenter()
              : { lat: 0, lng: 0 }
          "
          :disable-default-u-i="true"
          :zoom="14"
          style="width: 100%; height: 450px"
        >
          <gmap-info-window
            :conent="infoContent"
            :opened="infoOpened"
            :options="infoOptions"
            :position="infoPosition"
            @closeclick="infoOpened = false"
          >
            {{ infoContent }}
          </gmap-info-window>
          <GmapMarker
            v-for="(m, index) in customers"
            :key="m.id"
            :animation="2"
            :clickable="true"
            :draggable="false"
            :icon="getSiteIcon(m)"
            :label="m.check_number ? m.check_number.toString() : null"
            :position="getMarkers(m)"
            @click="toggleInfo(m, index)"
          />
        </GmapMap>
      </v-col>
    </v-row>
    <v-row class="mb-n6">
      <v-col>
        <v-btn
          class="btn-primary"
          @click="createPage()"
        >
          Next
          <v-icon>mdi-arrow-right-bold-circle-outline</v-icon>
        </v-btn>
      </v-col>
      <v-col>
        <h4>
          ລູກຄ້າທັງໝົດ {{ pagination.total }} ຄົນ
        </h4>
        <h4>ຂີ້ເຫຍື້ອຄາດໝາຍ:</h4>
        <h5
          v-for="item in countExpectTrash"
          :key="item.cost_by"
        >
          <div>
            {{
              getLaoCompanyCostByFunc(item.cost_by) +
                ": " +
                Intl.NumberFormat().format(item.expect_trash) +
                " " +
                getCustomerUnitFunc(item.cost_by)
            }}
          </div>
        </h5>
      </v-col>
      <v-col>
        <v-autocomplete
          v-model="selectedDistrict"
          :items="districts"
          clearable
          dense
          item-text="name"
          item-value="id"
          label="ເມືອງ"
          outlined
        />
      </v-col>
      <v-col>
        <v-autocomplete
          v-model="selectedVillage"
          :items="villages"
          chips
          clearable
          dense
          item-text="name"
          item-value="id"
          label="ເລືອກບ້ານ"
          multiple
          outlined
        >
          <template v-slot:selection="data">
            <v-chip
              :input-value="data.selected"
              close
              v-bind="data.attrs"
              @click="data.select"
              @click:close="remove(data.item)"
            >
              {{ data.item.name }}
            </v-chip>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>

    <!-- Village Detail -->
    <v-row>
      <VillageDetail
        v-model="selectedDetails"
        :selected-village="selectedVillage"
      />
    </v-row>

    <!-- Grade + display range -->
    <v-row dense>
      <v-col
        cols="12"
        sm="6"
      >
        <v-select
          v-model="selectedGrades"
          :items="gradeOptions"
          clearable
          dense
          hide-details
          label="Grade (ເກຣດລູກຄ້າ)"
          multiple
          outlined
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <v-select
          v-model="per_page"
          :items="perPageOptions"
          dense
          hide-details
          label="ຈຳນວນສະແດງ"
          outlined
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols>
        <v-select
          v-model="selectedFavoriteDate"
          :items="favorite_dates"
          dense
          item-text="name"
          item-value="name"
          label="ມື້ບໍລິການ"
          multiple
          outlined
        />
      </v-col>
      <v-col>
        <v-autocomplete
          v-model="selectedCustomerStatus"
          :items="customerStatus"
          clearable
          dense
          item-text="name"
          item-value="value"
          label="ສະຖານະລູກຄ້າ"
          multiple
          outlined
        />
      </v-col>
      <v-col>
        <v-autocomplete
          v-model="selectedCustomerCanCollects"
          :items="customerCanCollects"
          clearable
          dense
          item-text="text"
          item-value="value"
          label="ສະຖານະໃຫ້ເກັບ"
          outlined
        />
      </v-col>
      <v-col>
        <v-select
          v-model="selectedCost"
          :items="costs"
          clearable
          dense
          item-text="name"
          item-value="value"
          label="ປະເພດບໍລິການ"
          multiple
          outlined
        />
      </v-col>
      <v-col>
        <v-text-field
          v-model="search"
          clearable
          dense
          label="ຊື່ລູກຄ້າ"
          outlined
          prepend-inner-icon="mdi-magnify"
          type="text"
          @keyup.enter="Search()"
        />
      </v-col>
      <v-col>
        <v-btn
          color="green"
          dark
          style="width:100%"
          @click="fetchSearch"
        >
          ຄົ້ນຫາ
        </v-btn>
      </v-col>
    </v-row>

    <div>
      <v-card>
        <v-card flat>
          <v-card-text>
            <v-row v-if="selectedRows.length">
              <v-col>
                <p>ລູກຄ້າທີ່ເລືອກ {{ selectedRows.length }}</p>
              </v-col>
              <v-col
                v-for="trash in selectedTrash"
                :key="trash.cost_by"
              >
                <p>
                  {{
                    getLaoCompanyCostByFunc(trash.cost_by) +
                      ": " +
                      Intl.NumberFormat().format(trash.count) +
                      " " +
                      getCustomerUnitFunc(trash.cost_by)
                  }}
                </p>
              </v-col>
            </v-row>
            <v-data-table
              :disable-pagination="true"
              :headers="headers"
              :items="customers"
              :search="search"
              hide-default-footer
            >
              <template v-slot:item.village_details="{ item }">
                <v-chip
                  v-for="villageItem in item.village_details"
                  :key="villageItem.id"
                >
                  {{
                    `${villageItem.village_variation.name}: ${villageItem.name}`
                  }}
                </v-chip>
              </template>

              <template v-slot:item.can_collect="{ item }">
                <v-chip
                  dark
                  :color="item.can_collect ? 'green' : 'orange'"
                >
                  {{
                    item.can_collect ? 'ເກັບໄດ້': 'ເກັບບໍ່ໄດ້'
                  }}
                </v-chip>
              </template>

              <template v-slot:item.grade="{ item }">
                <v-chip
                  :color="gradeColor(gradeOf(item.fix_cost))"
                  dark
                  small
                >
                  {{ gradeOf(item.fix_cost) }}
                </v-chip>
              </template>

              <template v-slot:item.address_detail="{ item }">
                <div
                  v-for="(data, index) in item.village_details"
                  :key="index"
                >
                  <span>{{ data.name }}</span>
                </div>
              </template>
              <template v-slot:item.cost_by="{ item }">
                <div>{{ costBy(item.cost_by) }}</div>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-icon
                  class="mr-2"
                  small
                  @click="viewPage(item.id)"
                >
                  mdi-eye
                </v-icon>
              </template>
              <template v-slot:item.custom_pick="{ item }">
                <div
                  class="main-check"
                  @click="checkHandler(item)"
                >
                  <div
                    v-if="item.check_number"
                    class="check"
                  >
                    {{ item.check_number }}
                  </div>
                  <div
                    v-else
                    class="uncheck"
                  />
                </div>
              </template>

              <template v-slot:header.custom_pick="{}">
                <div @click="checkAllToggle()">
                  <div
                    v-if="checkAll"
                    class="check"
                  />
                  <div
                    v-else
                    class="uncheck"
                  />
                </div>
              </template>

              <template v-slot:item.expect_trash="{ item }">
                <v-chip
                  v-if="item.expect_trash"
                  color="green"
                  outlined
                >
                  {{ Intl.NumberFormat().format(item.expect_trash) }}
                  {{ getCustomerUnitFunc(item.cost_by) }}
                </v-chip>
                <div v-else>
                  -
                </div>
              </template>

              <template v-slot:item.favorite_dates="{ item }">
                <v-chip
                  v-for="date in item.favorite_dates"
                  :key="date.name"
                  color="green"
                  dark
                >
                  {{ date.name }}
                </v-chip>
              </template>
            </v-data-table>
            <br>
            <Pagination
              v-if="pagination.total_pages > 1"
              :offset="offset"
              :pagination="pagination"
              @paginate="fetchData()"
            />
          </v-card-text>
        </v-card>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import { GetOldValueOnInput } from '@/Helpers/GetValue';
import queryOption from '@/Helpers/queryOption';
import {
  getCustomerUnit,
  getLaoCompanyCostBy,
  getCompanyCostBy,
  getCustomerCanCollect,
} from '@/Helpers/Customer';
import VillageDetail from '@/components/select/VillageDetail';

// Hoisted so getSiteIcon returns a stable reference per pin type instead of a
// fresh object literal on every call — otherwise every parent re-render pushes
// a new icon identity into every GmapMarker and triggers setIcon on all of them.
const PIN1_ICON = {
  url: require('@coms/../../src/assets/pin1.svg'),
  zoomControl: true,
  mapTypeControl: false,
  scaleControl: false,
  streetViewControl: false,
  rotateControl: false,
  fullscreenControl: false,
  disableDefaultUi: false,
  size: {
    width: 35,
    height: 55,
    f: 'px',
    b: 'px',
  },
  scaledSize: {
    width: 35,
    height: 55,
    f: 'px',
    b: 'px',
  },
};
const PIN2_ICON = {
  url: require('@coms/../../src/assets/pin2.svg'),
  zoomControl: true,
  mapTypeControl: false,
  scaleControl: false,
  streetViewControl: false,
  rotateControl: false,
  fullscreenControl: false,
  disableDefaultUi: false,
  size: {
    width: 35,
    height: 55,
    f: 'px',
    b: 'px',
  },
  scaledSize: {
    width: 35,
    height: 55,
    f: 'px',
    b: 'px',
  },
};

export default {
  name: 'Customer',
  components: {
    VillageDetail,
  },
  data() {
    return {
      selectedDetails: [],
      tab: null,
      customers: [],
      selectedAllCustomer: [],
      customerCanCollects: getCustomerCanCollect,
      selectedCustomerCanCollects: '',
      countExpectTrash: [],
      loading: false,
      customerId: '',
      // Pagination
      offset: 12,
      pagination: {},
      per_page: 100,
      perPageOptions: [
        { text: '100', value: 100 },
        { text: '300', value: 300 },
        { text: '500', value: 500 },
        { text: '1000', value: 1000 },
        { text: 'ທັງໝົດ', value: 'all' },
      ],
      selectedGrades: [],
      gradeOptions: [
        { text: 'A (≥10M LAK)', value: 'A' },
        { text: 'B (5-10M LAK)', value: 'B' },
        { text: 'C (1-5M LAK)', value: 'C' },
        { text: 'D (<1M LAK)', value: 'D' },
      ],
      search: '',
      oldVal: '',
      // Filter
      districts: [],
      selectedDistrict: '',
      villages: [],
      selectedVillage: [],
      // selectedAllVillage: [],
      selectedCustomerStatus: [],
      customerStatus: [
        {
          id: 1,
          value: 'calendar',
          name: 'ຍັງບໍ່ມີແຜນເດີນລົດ',
        },
        {
          id: 2,
          value: 'route_plan',
          name: 'ຍັງບໍ່ມີເສັ້ນທາງເກັບຂີ້ເຫື້ຍອ',
        },
      ],
      selectedCost: [],
      costs: [
        {
          id: 1,
          value: 'container',
          name: 'ຄອນເທັນເນີ',
        },
        {
          id: 2,
          value: 'fix_cost',
          name: 'ທຸລະກິດເປັນຖ້ຽວ',
        },
        {
          id: 3,
          value: 'chartered',
          name: 'ມອບເໝົາ',
        },
        {
          id: 4,
          value: 'bag',
          name: 'ບໍລິມາດ',
        },
        {
          id: 5,
          value: '32km',
          name: 'ຫຼັກ32',
        },
        {
          id: 6,
          value: 'infect',
          name: 'ຂີ້ເຫຍື້ອຕິດເຊື້ອ',
        },
      ],
      favorite_dates: [],
      selectedFavoriteDate: [],
      selectedRows: [],
      headers: [
        { text: '', value: 'custom_pick', sortable: false },
        { text: 'ID', value: 'customer_id' },
        { text: 'ບໍລິສັດ', value: 'company_name' },
        // { text: "ຜູ້ຮບຜິດຊອບ", value: "company_coordinators.name" },
        { text: 'ປະເພດບໍລິການ', value: 'cost_by_la', sortable: true },
        { text: 'ສະຖານະໃຫ້ເກັບ', value: 'can_collect' },
        { text: 'ລາຍລະອຽດທີ່ຢູ່', value: 'village_details', sortable: true },
        { text: 'ບ້ານ', value: 'village.name', sortable: true },
        { text: 'ເມືອງ', value: 'district.name', sortable: true },
        // {text: "ລາຍລະອຽດທີ່ຢູ່", value: "address_detail"},
        { text: 'ລາຍລະອຽດການບໍລິການ', value: 'collect_description' },
        { text: 'ຂີ້ເຫຍື້ອຄາດໝາຍ', value: 'expect_trash' },
        { text: 'ວັນທີ່ສະດວກເກັບ', value: 'favorite_dates' },
        { text: 'ວັນທີ່ເພີ່ມເຂົ້າ', value: 'created_at' },
        // { text: "ເຮືອນເລກທີ", value: "house_number", sortable: false },
        {
          text: 'Grade',
          value: 'grade',
          align: 'center',
          sortable: false,
        },
        { text: '', value: 'actions', sortable: false },
      ],
      // Map
      latlng: {
        lat: 0,
        lng: 0,
      },
      markers: [],
      places: [],
      currentPlace: null,
      infoPosition: null,
      infoContent: null,
      infoOpened: false,
      infoCurrentKey: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      last_check_number: 0,
      checkAll: false,
      // Set for the duration of a programmatic clearSelection() call (and
      // the async flush it triggers). checkAll's watcher id is lower than
      // every filter watcher's, so setting checkAll = false inside
      // clearSelection() gets spliced into the *currently running* flush
      // queue and executes after the filter watcher's own body (and its
      // fetchData() calls) have already returned — i.e. potentially while a
      // refetch is in flight. This flag lets that watcher recognize it was
      // re-entered programmatically and skip its body (in particular its
      // Loading_State commits, which must never land in the middle of a
      // refetch) since clearSelection() already did the equivalent work
      // synchronously via deselectAll(). It is not set when the operator
      // clicks the header checkbox directly, so that path is unaffected.
      clearingSelection: false,
      // Monotonic request ids so a slow response can't overwrite a fresher
      // one (e.g. picking ທັງໝົດ then quickly picking Grade A). The main
      // fetch and the countexpect fetch share fetchData() but are tracked
      // independently since one must not invalidate the other.
      fetchRequestId: 0,
      countExpectRequestId: 0,
    };
  },
  computed: {
    selectedTrash() {
      const array = [];

      for (const item of getCompanyCostBy) {
        array.push({
          cost_by: item.en,
          count: 0,
        });
      }

      for (const selected of this.selectedRows) {
        const index = array.findIndex(
          (item) => item.cost_by == selected.cost_by,
        );
        if (index > -1) {
          array[index].count
              += selected.expect_trash > 0 ? selected.expect_trash : 0;
        }
      }

      return array;
    },
    selectedAllVillage() {
      return this.selectedVillage.length === this.villages.length;
    },
    selectedSomeVillage() {
      return this.selectedVillage.length && !this.selectedAllVillage;
    },
    icon() {
      if (this.selectedAllVillage) return 'mdi-close-box';
      if (this.selectedSomeVillage) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },
  },
  watch: {
    // Any watcher that changes WHICH customers match (district, village,
    // village-details, status, can-collect, cost_by, grade, favorite dates,
    // search) must call clearSelection() — old picks may not be in the new
    // result set, and createPage() would otherwise push stale rows into the
    // route plan. per_page and Pagination's @paginate only change which
    // slice of the same result set is rendered, so they preserve selection.
    checkAll(value) {
      // Re-entered programmatically from clearSelection() (see
      // `clearingSelection` above) — clearSelection() already blanked the
      // badges and reset selectedRows/last_check_number synchronously, and
      // toggling Loading_State here would land mid-refetch. Skip the body
      // entirely; this never affects the operator's own header-click path,
      // which runs with clearingSelection == false exactly as before.
      if (this.clearingSelection) return;

      // Linear, single reactive update: at ~3,700 rows the old per-row
      // checkHandler()/splice() loop did ~14M iterations plus ~3,700 full
      // re-renders of the table and every map marker. Assign check_number
      // in one pass, then replace `customers` (and selectedRows /
      // last_check_number) exactly once.
      this.$store.commit('Loading_State', true);
      if (value == true) {
        this.customers.forEach((customer, i) => {
          customer.check_number = i + 1;
        });
        this.customers = this.customers.slice();
        this.selectedRows = this.customers.slice();
        this.last_check_number = this.customers.length;
      } else {
        this.deselectAll();
      }
      this.$store.commit('Loading_State', false);
    },
    selectedCustomerCanCollects() {
      this.pagination.current_page = '';
      this.clearSelection();
      this.fetchData();
      this.fetchData(true);
    },
    per_page() {
      this.pagination.current_page = '';
      this.fetchData();
      this.fetchData(true);
    },
    selectedGrades() {
      this.pagination.current_page = '';
      this.clearSelection();
      this.fetchData();
      this.fetchData(true);
    },
    selectedFavoriteDate() {
      this.pagination.current_page = '';
      this.clearSelection();
      this.fetchData();
      this.fetchData(true);
    },
    search(value) {
      this.pagination.current_page = '';
      // clearable's ✕ sets the field to null, not '' — match both so the
      // clear button actually clears the selection and refetches, per the
      // block comment above.
      if (value == '' || value == null) {
        this.oldVal = '';
        this.clearSelection();
        this.fetchData();
        this.fetchData(true);
      }
    },
    selectedVillage() {
      this.pagination.current_page = '';
      this.clearSelection();
      // this.fetchData();
      // this.fetchData(true)
    },
    selectedDistrict() {
      this.pagination.current_page = '';
      this.clearSelection();
      this.fetchVillage();
      // this.fetchData();
      // this.fetchData(true)
    },
    selectedDetails(value, oldValue) {
      // VillageDetail re-emits `input` with a freshly-reassigned (but still
      // logically empty) array both on its own mount and ~300ms-2s after a
      // district/village pick resolves, well after the operator has moved
      // on and possibly ticked rows. Neither case is a real operator pick,
      // so ignore the emit when both the new and previous value are empty.
      // A genuine pick (or genuine clear of a real pick) always has at
      // least one non-empty side and still clears the selection below.
      // The reset below only runs past the emptiness guard, so the mount-time
      // and post-pick spurious emits (both empty-to-empty) never touch it —
      // it only fires on a genuine pick/clear, where a stale current_page
      // would otherwise survive a search() that also doesn't reset it.
      const isEmpty = (arr) => !arr || arr.length === 0;
      if (isEmpty(value) && isEmpty(oldValue)) return;
      this.pagination.current_page = '';
      this.clearSelection();
    },
    selectedCustomerStatus() {
      this.pagination.current_page = '';
      this.clearSelection();
      this.fetchData();
      this.fetchData(true);
    },
    selectedCost() {
      this.pagination.current_page = '';
      this.clearSelection();
      this.fetchData();
      this.fetchData(true);
    },
  },
  created() {
    this.fetchData();
    this.fetchData(true);
    this.fetchAddress();
    this.fetchFavorite();
  },
  methods: {
    checkAllToggle() {
      this.checkAll = !this.checkAll;
    },
    // Single point of truth for wiping a selection: called from every filter
    // path (watchers above, fetchSearch(), Search()) whenever the matching
    // result set is about to change. Blanks the check_number badges itself
    // (via deselectAll()) instead of relying on the checkAll watcher, so
    // orphan badges can't survive a failed refetch when checkAll was never
    // true (manual selection). Setting checkAll = false afterwards keeps the
    // header checkbox visually in sync and, when checkAll was true, re-enters
    // the checkAll watcher — but `clearingSelection` tells that watcher to
    // skip its body (see the flag's comment above), so its Loading_State
    // commits can never land in the middle of a refetch, and the redundant
    // deselectAll() work never re-runs. The flag is cleared on nextTick,
    // after Vue's watcher flush (which is what actually runs the re-entrant
    // checkAll watcher) has completed.
    clearSelection() {
      this.clearingSelection = true;
      try {
        this.deselectAll();
        this.checkAll = false;
      } finally {
        this.$nextTick(() => {
          this.clearingSelection = false;
        });
      }
    },
    // Blanks every row's check_number badge and resets selectedRows /
    // last_check_number in one pass. Shared by clearSelection() (manual
    // selection / programmatic clear) and the checkAll watcher's own
    // deselect branch (operator unticks the header checkbox), so both pay
    // the same single-pass cost the checkAll watcher's comment above
    // describes.
    deselectAll() {
      // Nothing to clear: check_number is only ever set alongside
      // selectedRows/last_check_number (checkAll's true branch and
      // checkHandler both update all three together), and fetchData()
      // always replaces `customers` with fresh server objects that never
      // carry a check_number field. So when both counters are already zero,
      // no row can have a check_number to blank — skip the walk and the
      // array reassign (and the full data-table/GmapMarker re-diff it
      // forces) entirely.
      if (!this.selectedRows.length && !this.last_check_number) return;
      this.customers.forEach((customer) => {
        customer.check_number = null;
      });
      this.customers = this.customers.slice();
      this.selectedRows = [];
      this.last_check_number = 0;
    },
    fetchSearch() {
      this.clearSelection();
      this.fetchData();
      this.fetchData(true);
    },
    backPrevios() {
      this.$router.go(-1);
    },
    getCustomerUnitFunc(costBy) {
      return getCustomerUnit(costBy);
    },
    getLaoCompanyCostByFunc(costBy) {
      return getLaoCompanyCostBy(costBy);
    },

    checkHandler(value) {
      const index = this.customers.findIndex((item) => item.id == value.id);
      if (index != -1) {
        if (this.customers[index].check_number) {
          if (this.customers[index].check_number == this.last_check_number) {
            this.last_check_number--;
            this.customers[index].check_number = null;
            this.selectedRows.pop();
          }
        } else {
          this.last_check_number++;
          this.customers[index].check_number = this.last_check_number;
          this.selectedRows.push(value);
        }
        this.customers.splice(index, 1, this.customers[index]);
      }
    },
    chooseStyle() {
      return 'check';
    },
    async fetchData(countexpect = false) {
      // Monotonic request id, tracked separately for the main fetch and the
      // countexpect fetch (they share this method but must not invalidate
      // each other). Guards against a slow 'all'-range response landing
      // after a faster filtered one and overwriting it.
      const requestId = countexpect
        ? (this.countExpectRequestId += 1)
        : (this.fetchRequestId += 1);

      try {
        const options = [
          { page: this.pagination.current_page },
          // ທັງໝົດ omits per_page entirely; the backend then returns every
          // matching row as a plain array instead of a paginated envelope.
          { per_page: this.per_page === 'all' ? undefined : this.per_page },
          { without: this.selectedCustomerStatus },
          { without_month_info: true },
          { without_billing_summary: true },
          { without_customer_activity: true },
          { villages: this.selectedVillage },
          { district_id: this.selectedDistrict },
          { filter: this.search },
          { cost_by: this.selectedCost },
          { grade: this.selectedGrades },
          { favorite_dates: this.selectedFavoriteDate },
          { village_details: this.selectedDetails },
          { customer_can_collect: this.selectedCustomerCanCollects },
        ];

        if (countexpect) options.push({ count_expact_trash: '1' });

        this.$store.commit('Loading_State', true);

        const res = await this.$axios.get('company', {
          params: queryOption(options),
        });

        if (res.data.code == 200) {
          setTimeout(() => {
            this.$store.commit('Loading_State', false);

            const isStale = countexpect
              ? requestId !== this.countExpectRequestId
              : requestId !== this.fetchRequestId;
            if (isStale) return;

            if (countexpect) {
              this.countExpectTrash = res.data.data;
            } else {
              if (Array.isArray(res.data.data)) {
                this.customers = res.data.data;
                this.pagination = {
                  current_page: 1,
                  total_pages: 1,
                  total: res.data.data.length,
                };
              } else {
                this.customers = res.data.data.data;
                this.pagination = res.data.data.pagination;
              }
              this.selectedAllCustomer = this.customers;
            }
          }, 100);
        }
      } catch (error) {
        this.$store.commit('Loading_State', false);

        this.$store.commit('Toast_State', {
          value: true,
          color: 'error',
          msg: error.response ? error.response.data.message : 'Something went wrong',
        });

        if (error.response && error.response.status == 422) {
          const obj = error.response.data.error;
          for (const [key, message] of Object.entries(obj)) {
            this.server_errors[key] = Array.isArray(message) ? message[0] : message;
          }
        }

        if (error.response && error.response.status == 422) {
          const obj = error.response.data.errors || error.response.data.data || {};
          for (const [key, message] of Object.entries(obj)) {
            this.server_errors[key] = Array.isArray(message) ? message[0] : message;
          }
        }
      }
    },

    fetchAddress() {
      this.$axios
        .get('info/address', { params: { filter: 'ນະຄອນຫລວງວຽງຈັນ' } })
        .then((res) => {
          if (res.data.code == 200) {
            setTimeout(() => {
              this.address = res.data.data;
              this.address.map((item) => {
                this.districts = item.districts;
              });
            }, 300);
          }
        })
        .catch(() => {
        });
    },

    fetchVillage() {
      if (this.selectedDistrict) {
        this.$axios
          .get(`info/district/${this.selectedDistrict}/village`)
          .then((res) => {
            if (res.data.code == 200) {
              setTimeout(() => {
                this.villages = res.data.data;
              }, 300);
            }
          })
          .catch(() => {
          });
      }
    },

    createPage() {
      //  var a = [];
      if (this.selectedRows.length) {
        this.$router.push({
          name: 'CreateRoutePlanCompany',
          params: {
            items: this.selectedRows,
          },
        });
      } else {
        this.$store.commit('Toast_State', {
          value: true,
          color: 'error',
          msg: 'ກາລຸນາເລືອກບ້ານ ແລະ ລູກຄ້າກ່ອນ',
        });
      }
    },
    viewPage(id) {
      this.$router.push({
        name: 'ViewClient',
        params: { id },
      });
    },
    remove(item) {
      const index = this.selectedVillage.indexOf(item.id);
      if (index >= 0) this.selectedVillage.splice(index, 1);
    },
    Search() {
      // Unconditional clear: GetOldValueOnInput() is a shared helper (used
      // across dozens of other views) that only fetches when the text
      // actually changed since the last search. Replicating that gate here
      // would duplicate its internal oldVal/search comparison; clearing
      // unconditionally on every Enter-press is the simpler, safe-by-default
      // choice — worst case is an unnecessary clear on a no-op re-submit,
      // never a stale over-broad selection surviving a real search change.
      this.clearSelection();
      GetOldValueOnInput(this);
    },

    // Google map
    getCenter() {
      if (this.customers && this.customers.length) {
        if (parseFloat(this.customers[0].lat) == null) {
          return this.latlng;
        }
        const latlng = {
          lat: parseFloat(this.customers[0].lat),
          lng: parseFloat(this.customers[0].lng),
        };
        return latlng;
      }
      return this.latlng;
    },
    getMarkers(m) {
      if (m.customer !== null) {
        return {
          lat: parseFloat(m.lat),
          lng: parseFloat(m.lng),
        };
      }
    },
    getSiteIcon(status) {
      // 0 plans = pin1 (red), in a plan (1 or more) = pin2 (blue). Icons are
      // hoisted module-level constants so this always returns a stable
      // reference instead of a new object literal per call.
      try {
        switch (status.route_plan_details_count) {
          case 0:
            return PIN1_ICON;
          default:
            return PIN2_ICON;
        }
      } catch (e) {
        return PIN1_ICON;
      }
    },
    toggleInfo(m, key) {
      this.infoPosition = this.getMarkers(m);
      this.infoContent = `${m.company_name} (${m.user.phone}) `;
      if (this.infoCurrentKey == key) {
        this.infoOpened = !this.infoOpened;
      } else {
        this.infoOpened = true;
        this.infoCurrentKey = key;
      }

      this.checkHandler(m);
    },

    toggle() {
      this.$nextTick(() => {
        if (this.selectedAllVillage) {
          this.selectedVillage = [];
        } else {
          setTimeout(() => {
            this.selectedVillage = this.villages.slice();
          }, 300);
        }
      });
    },
    costBy(value) {
      if (value == 'container') return 'ຄອນເທັນເນີ';
      if (value == 'fix_cost') return 'ທຸລະກິດເປັນຖ້ຽວ';
      if (value == 'chartered') return 'ມອບເໝົາ';
      if (value == 'infect') return 'ຂີ້ເຫຍື້ອຕິດເຊື້ອ';
      if (value == '32km') return 'ຫຼັກ32';
      return value;
    },
    gradeOf(fixCost) {
      if (fixCost >= 10000000) return 'A';
      if (fixCost >= 5000000) return 'B';
      if (fixCost >= 1000000) return 'C';
      return 'D';
    },
    gradeColor(value) {
      if (value == 'A') return 'green';
      if (value == 'B') return 'blue';
      if (value == 'C') return 'orange';
      return 'grey';
    },
    fetchFavorite() {
      this.$axios
        .get('favorite-date')
        .then((res) => {
          if (res.data.code == 200) {
            setTimeout(() => {
              this.favorite_dates = res.data.data;
            }, 100);
          }
        })
        .catch(() => {
        });
    },
  },
};
</script>

<style lang="scss">
@import "../../../../public/scss/main.scss";

.check {
  height: 20px;
  width: 100%;
  background-color: cornflowerblue;
  color: white;
  text-align: center;
}

.uncheck {
  height: 20px;
  width: 20px;
  border: 1px solid black;
}

.main-check {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
